import { useEffect } from 'react'

export const useDebouncedEffect = (effect: () => any, query: any, page: any, delay: number) => {
	useEffect(() => {
		const handler = setTimeout(() => effect(), delay)
		return () => clearTimeout(handler)
	}, [query, page, delay, effect])
}
